// IE 2026 11 03 / ODOO-5800 (ie-dm7 #128579: согласование правил MAP-*, этап C) — КАРТА ОБЪЯСНЕНИЙ ОБЛАСТИ «ruleApproval»: кнопка «Approval» со сводкой
// в списке правил карты, её команды, пилюля статуса строки, кнопка и окно «Approval» формы правила. Формат записи — как у прочих областей (utils/uiHelp.js).
// Тексты — английские литералы в t() (словари uk / ru — src/i18n/messages). Проверка записей — tests/unit/ruleApproval.test.mjs
import { t } from '@/i18n'

const G = { setting: 'fe.ux.ruleApproval', settingGate: 'fe.ux.ruleApproval', settingDefault: false }   // IE 2026 11 03 / ODOO-5800 (webscm #128969: блокер выката — форма согласования правил по умолчанию выключена): дефолт ВЫКЛ, как ruleApproval_on
const ruleApproval = {
    'ruleApproval.menu': (vars) => ({
        title: t('Rule approval'),
        now: (vars && vars.summary) || '',
        what: t('How many rules of the map are approved, not approved, changed after the approval or rejected; the menu requests, approves, rejects or withdraws the approval of the selected rules.'),
        why: t('A changed planning rule (lead time, packaging, stock days…) is applied only after its owner approves it.'),
        click: t('Select rules (or check them) and pick a command; the list of rules is shown for confirmation, Reject and Withdraw ask for a comment.'),
        affects: t('Writes the approval status of the rules and an approval event; the map itself does not change.'),
        stored: t('Rule approval records and approval events in the database'),
        ...G,
    }),
    'ruleApproval.cmd.request': () => ({
        title: t('Request approval'),
        what: t('Asks the owner of each selected rule to approve it.'),
        why: t('The owner sees the request in the approval status of the rule.'),
        click: t('Select rules and click; a comment is optional.'),
        affects: t('Marks the rules as requested; a repeated request is refused.'),
        ...G,
    }),
    'ruleApproval.cmd.approve': () => ({
        title: t('Approve'),
        what: t('Approves the current values of the selected rules: they become the approved snapshot.'),
        why: t('Later changes of the approved fields show the rule as changed after approval.'),
        click: t('Only the rule owner from the responsibles register can approve; select the rules and click.'),
        affects: t('Status → Approved; the snapshot of the fields is saved.'),
        ...G,
    }),
    'ruleApproval.cmd.reject': () => ({
        title: t('Reject'),
        what: t('Rejects the selected rules with a comment.'),
        why: t('Tells the author what to fix in the rule.'),
        click: t('Select rules and click; the comment is required.'),
        affects: t('Status → Rejected.'),
        ...G,
    }),
    'ruleApproval.cmd.withdraw': () => ({
        title: t('Withdraw approval'),
        what: t('Withdraws the approval of the selected rules with a comment.'),
        why: t('An approved rule that must be reviewed again returns to Not approved.'),
        click: t('Select rules and click; the comment is required.'),
        affects: t('Status → Not approved; the history keeps the earlier decisions.'),
        ...G,
    }),
    'ruleApproval.cmd.history': () => ({
        title: t('History'),
        what: t('The decisions on the rule: who, when, the status before and after, the comment and the changed fields.'),
        why: t('To see why the rule is in its status.'),
        click: t('Select one rule and click.'),
        affects: t('Nothing — reading only.'),
        ...G,
    }),
    'ruleApproval.pill': (vars) => ({
        title: t('Rule approval'),
        now: (vars && vars.now) || '',
        what: t('The approval status of the rule: not approved, approved, changed after approval (the mark) or rejected.'),
        why: t('Shows which rules are applied as approved by their owner.'),
        click: t('Use the Approval button of the list or open the rule.'),
        affects: t('Nothing — the status is set by the decisions.'),
        stored: t('Rule approval records in the database'),
        ...G,
    }),
    'ruleApproval.formButton': () => ({
        title: t('Rule approval'),
        what: t('The approval status of this rule; the button opens the approval window.'),
        why: t('To approve the rule or to see what changed after the approval.'),
        click: t('Click to open the window.'),
        affects: t('Nothing — opens the window.'),
        ...G,
    }),
    'ruleApproval.form': () => ({
        title: t('Rule approval'),
        what: t('The status of the rule, who approved it and when, the fields changed after the approval (approved → now), the commands and the history.'),
        why: t('The owner checks the changes before approving the rule again.'),
        click: t('Pick a command; Reject and Withdraw ask for a comment.'),
        affects: t('Writes the approval status of the rule and an approval event; the map itself does not change.'),
        stored: t('Rule approval records and approval events in the database'),
        ...G,
    }),
}
export default ruleApproval
